import { Duration } from 'luxon';

export type IConvertedAzureUnits = {
    days: number;
    hours: number;
    minutes: number;
};

export const convertAzureTime = (azureTime: string): IConvertedAzureUnits => {
    const duration = Duration.fromISO(azureTime);
    return {
        days: isNaN(duration.days) ? 0 : duration.days,
        hours: isNaN(duration.hours) ? 0 : duration.hours,
        minutes: isNaN(duration.minutes) ? 0 : duration.minutes,
    };
};
